import domainForm from './domainForm'
import domainStatus from './domainStatus'
import addDomainView from './addDomainView'

export default {
  title: 'Adicionar domínio',
  headingTitle: 'Adicionar domínio',
  description: `Um domínio é um endereço de um site (ex: www.nomedaempresa.com.br).
                Você pode adicionar um domínio que tenha comprado, definir um domínio
                temporário como principal, incluir domínios alternativos que apontem para o
                mesmo site, alterar ou excluir domínios.`,
  verifyFailure: 'Erro ao verificar domínio.',
  domainForm,
  domainStatus,
  addDomainView
}
